import React, { useState, useContext, useEffect } from 'react';
import apiClient from '../../utils/apiClient';
import '../../styles/Header.css';
import { ProfileContext } from '../../contexts/ProfileContext';
import userAvatar from '../../assets/icons/user-avatar.jpg';
import NotificationWidget from './NotificationWidget';
import SettingsWidget from './SettingsWidget';
import ConfirmationModal from '../UI/ConfirmationModal';
import TokenService from '../../utils/tokenService';
import { useDispatch } from 'react-redux';
import { resetTheme, saveTheme, updateImageFileName } from '../../store/themeSlice';
import BrandingService from '../../utils/brandingService';



const defaultTheme = {
  'color-primary': 'rgb(75, 108, 135)',
  'color-secondary': '#333',
  'color-bg': 'rgb(244, 243, 248)',
  'color-sidebar-bg': 'white',
  'color-text': '#ffffff',
  'color-landing-left': '#fff',
  'color-landing-right': 'linear-gradient(174deg, #BC7E30 4%, #ECBE84 52.8%)',
};


const Header = () => {
  const { profile, refreshProfile } = useContext(ProfileContext);
  const dispatch = useDispatch();
  const [showRestore, setShowRestore] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const idInfo = TokenService.getIdTokenInfo();
    if (!idInfo) {
      setShowRestore(false);
      return;
    }
    const currentTenant = idInfo?.['custom:tenant'] || '';
    const defaultTenant = idInfo?.['custom:default_tenant'] || '';
    setShowRestore(!!(currentTenant && defaultTenant && currentTenant !== defaultTenant));
  }, [profile]);

  const handleRestoreTheme = async () => {
    const idInfo = TokenService.getIdTokenInfo() || {};
    const defaultTenant = idInfo['custom:default_tenant'];
    if (!defaultTenant) return;

    try {
      await apiClient.post('/impersonate', { TargetTenantName: defaultTenant });
      
      BrandingService.clearAll();
      dispatch(resetTheme());
      await refreshProfile();
    } catch (error) {
      console.error('Impersonation failed:', error);
      setErrorMessage('Failed to impersonate tenant. Please try again.');
      setShowErrorModal(true);
    }
  };

  return (
    <header className="header">
      <div className="header-icons">
        {showRestore && (
          <button className="restore-button" onClick={handleRestoreTheme}>
            Restore Theme
          </button>
        )}
        <ConfirmationModal
          isOpen={showErrorModal}
          message={errorMessage}
          confirmLabel="OK"
          showCancel={false}
          isDanger = {false}
          onConfirm={() => setShowErrorModal(false)}
        />

        <NotificationWidget />
        <SettingsWidget />
        <div className="header-user">
          <span>Hello, {profile?.Name || 'User'}</span>
          <img
            src={profile?.Picture || userAvatar}
            alt="User"
            className="user-avatar"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;